export const colors = [
  '#ff6961',
  '#00B5D5',
  '#7ae600', // B4F8C8
  '#f0e400', // FFD898
  '#FFAEBC',
  '#aec6cf',
  '#A8D9F8',
  '#ECF87F',
  '#C8DF52',
  '#4edfa5',
  '#FEDA15',
  '#7E9DC2',
  '#DBE8D8',
  '#C84D60',
  '#fdfd96',
  '#FFEED5',
  '#CAD6E7',
  '#77dd77',
  '#FF9636'
]

export const colorsCount = colors.length

export const barColors = [
  '#B4F8C8',
  '#ECF87F',
  '#C8DF52',
  '#FEDA15',
  '#7E9DC2',
  '#DBE8D8',
  '#C84D60',
  '#FDFD96',
  '#FFEED5',
  '#CAD6E7',
  '#77dd77',
  '#FF9636',
  '#00B5D5',
  '#ff6961',
  '#FFAEBC',
  '#aec6cf',
  '#A8D9F8',
  '#FFD898'
]

export const barColorsCount = barColors.length

export const senseMap = {
  planned: colors[3], // планируемое значние - желтый, неопределенный
  defacto: colors[9], // фактическое значение - зеленый, позитивный

  average: colors[9], // среднее значение - зеленый, позитивный
  max: colors[1], // максимальное значение - нейтральный

  winner: colors[9], // победители - зеленый, позитивный
  canceled: colors[0], // отмененные - красный, негативный
  incomplete: colors[3], // незавершенные - желтый, неопределенный
  total: colors[1], // суммарное значение - нейтральный

  new: colors[1] // например новый конкурс - голубой/синий, свежий
}
